<template>
  <base-dialog
    :title="'room.param.area.title' | i18n"
    :subtitle="'room.param.area.subtitle' | i18n"
    :description="'room.param.area.description' | i18n">

    <div class="container-fluid" style="padding: 0;">
      <div class="row">
        <div class="col-4">
          <img src="../../assets/param/common_area.png" />
        </div>

        <div class="col-8">
          <label>Pinta-ala (huoneala 1,0 - 99,9 hum2)</label>
          <input-number v-model="area" :decimals="1" :min="1.0" :max="99.9" />
        </div>
      </div>
    </div>
  </base-dialog>
</template>


<script>
  import Vue from 'vue'
  import BaseDialog from "./BaseDialog"
  import townService from "../../api/townService";

  export default {
    computed: {
      area: {
        get() {
          return this.$store.state.roomParams.area
        },
        set(area) {
          this.$store.commit('roomParams/SET_AREA', area)
        }
      }
    },

    created() {
      if(this.area == null) {
        this.$store.commit('roomParams/SET_AREA', 8)
      }
    },

    components: {
      BaseDialog
    }
  }
</script>

<style scoped>
  img {
    max-width: 100%;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/RoomAreaDialog.vue